import { TrimCjBitmap, TrimCjContainer, TrimCjShape } from '../../../../model/cj-factory';
import { OrderPageDataXml } from '../../../../../xml/class/order/order-page-data-xml';
import { TrimPrintManager } from '../../../../print/trim.print';
import { TrimEditableImageManager } from '../../../editable-image/trim.editable-image.manager';
import { initPictureFlags, TrimImageController } from '../../../image-edit/image/trim.image-controller';
import { PrintBase } from '../../../../model/trim.print-model';
import {
  CJ_BGIMAGE_NAME,
  CJ_CONTAINER_NAME,
  CJ_DPOBJ_NAME, CJ_FRAME_NAME,
} from '../../../../model/cj-factory/trim.cj-obj-name.collection';
import { OrderFrameType, OrderPictureType } from '../../../../../models/api/front/layout';
import { TrimCjTool } from '../../../../../utilities/trim.cj-tool';
import { TrimUiManager } from '../../../ui/trim.ui.manager';
import { ThumbImageCreator } from './thumb.image.creator';
import { ThumbCreatorManager } from '../thumb.creator.manager';
import { TrimAdditionalManager } from '../../../additional/trim.additional.manager';
import { TrimCjGraphics } from '../../../../model/cj-factory/trim.cj-graphics';
import { ThumbTextCreator } from './thumb.text.creator';
import PixelConverter from '../../../../../utilities/pixel-converter';
import { NO_EDGE_TYPE } from '../../../image-edit/frame/trim.frame-controller';

export type HighlightType = {
  pageId?: string;
  photoAreaId?: string;
  category?: 'highlight';
} & TrimCjShape
export type WindowType = {
  pageId?: string;
  photoAreaId?: string;
  category?: 'window';
} & TrimCjShape

export class ThumbTempCreator {
  private stage: TrimCjContainer;
  public orderPage?: OrderPageDataXml;

  // printData: PrintBase = {
  //   id: '',
  //   realWidth: 0,
  //   realHeight: 0,
  //   temp: {
  //     real: {width: 0, height: 0},
  //     virtual: {width: 0, height: 0}
  //   },
  //   window: []
  // };

  private printManager!: TrimPrintManager;
  private thumbCreatorManager!: ThumbCreatorManager;
  private thumbImageCreator!: ThumbImageCreator;
  private trimAdditionalManager!: TrimAdditionalManager;
  private thumbTextCreator!: ThumbTextCreator;


  constructor(
    stage: TrimCjContainer,
  ) {
    this.stage = stage;
  }

  di(
    printMng: TrimPrintManager,
    thumbImageCreator: ThumbImageCreator,
    trimAdditionalMng: TrimAdditionalManager,
    thumbTextCreator: ThumbTextCreator,
    thumbCreatorMng: ThumbCreatorManager,
  ): void {
    this.printManager = printMng;
    this.thumbImageCreator = thumbImageCreator;
    this.trimAdditionalManager = trimAdditionalMng;
    this.thumbTextCreator = thumbTextCreator;
    this.thumbCreatorManager = thumbCreatorMng;
  }

  initialize(orderPage?: OrderPageDataXml) {
    this.orderPage = orderPage;
  }

  destroy() {
  }

  update(stage: TrimCjContainer): void {
    this.stage = stage;
  }

  createGuide() {

    const print = this.printManager.currentPrint;
    const base = print?.base.getImageWindow();
    const fills = print?.base.getFillWindow();
    const guidWidth = 1.5;
    // NOTE: フチなしの商品と白フチ商品の判別がテンプレートではできないためハードコーディング
    const isNoEdge = print?.item.productData?.meta?.borderType === NO_EDGE_TYPE;
    if (!base) return;
    const edgeTmp = isNoEdge ? undefined : this.printManager.getEdge(base.virtual.wh, fills?.length ? fills : []);
    const guideWidth = PixelConverter.mmToPx( guidWidth) / 2;
    const guidePos = {
      x: isNoEdge ? guideWidth/2 + base.virtual.pos.x : guideWidth/2,
      y: isNoEdge ? guideWidth/2 + base.virtual.pos.y : guideWidth/2,
    }
    const container = new TrimCjContainer();
    container.name = CJ_CONTAINER_NAME.guide;
    const shape = new TrimCjShape();
    const shapeLine = new TrimCjShape();
    shape.graphics.setStrokeStyle(guideWidth).beginStroke('rgba(0, 0, 0, 0.7)').dr(guidePos.x, guidePos.y, this.thumbCreatorManager.templateBaseVirtual.w - guideWidth, this.thumbCreatorManager.templateBaseVirtual.h - guideWidth);
    shapeLine.graphics.beginStroke('rgba(255, 0, 0, 0.4)').dr(guidePos.x, guidePos.y, this.thumbCreatorManager.templateBaseVirtual.w - guideWidth, this.thumbCreatorManager.templateBaseVirtual.h - guideWidth);
    shape.name = CJ_BGIMAGE_NAME.guide;
    shapeLine.name = CJ_BGIMAGE_NAME.guideLine;
    container.set({ x: edgeTmp?.virtual.pos.x ?? 0, y: edgeTmp?.virtual.pos.y ?? 0 });
    container.addChild(shape, shapeLine);
    this.stage.addChild(container);
  }

  // - マスク -
  createBgImage() {
    const print = this.printManager.currentPrint;
    const base = print?.base.getImageWindow();
    if (!base) {
      throw new Error('printModel is notFound !!!!!!!!!')
    }
    const {virtual} = base;
    const {pos, wh} = virtual;
    const container = new TrimCjContainer();
    container.name = CJ_CONTAINER_NAME.base
    const shape = new TrimCjShape();
    shape.graphics.f('#d30f7c').dr(0, 0, wh.width, wh.height);
    shape.name = CJ_BGIMAGE_NAME.base;
    shape.setBounds(0, 0, wh.width, wh.height);
    container.set({x: pos.x, y: pos.y});
    container.addChild(shape);
    this.stage.addChild(container)
  }

  createEdge() {
    const print = this.printManager.currentPrint;
    const base = print?.base.getImageWindow();
    const fills = print?.base.getFillWindow();
    // NOTE: フチなしの商品と白フチ商品の判別がテンプレートではできないためハードコーディング
    const isNoEdge = print?.item.productData?.meta?.borderType === NO_EDGE_TYPE;
    if (!base || isNoEdge) return;

    const edgeTmp = this.printManager.getEdge(base.virtual.wh, fills ?? [])
      const container = new TrimCjContainer();
      container.name = CJ_CONTAINER_NAME.edge;
      const shape = new TrimCjShape();
    if (edgeTmp) {
      const {virtual} = edgeTmp;
      const {pos, wh} = virtual;
      // shape.graphics.f(  '#fff').dr(pos.x, pos.y, wh.width, wh.height);
      shape.graphics.f( edgeTmp.fill?.color ?? '#fff').dr(0, 0, wh.width, wh.height);
      shape.name = CJ_BGIMAGE_NAME.edge;
      shape.setBounds(0, 0, wh.width, wh.height);
      container.set({x: pos.x, y: pos.y});
    } else {
      const {virtual} = base;
      const {pos, wh} = virtual;
      const width = wh.width + (pos.x * 2);
      const height = wh.height + (pos.y * 2);
      // shape.graphics.f(  '#fff').dr(pos.x, pos.y, wh.width, wh.height);
      shape.graphics.f( '#fff').dr(0, 0, width, height);
      shape.name = CJ_BGIMAGE_NAME.edge;
      shape.setBounds(0, 0, width, height);
    }
      container.addChild(shape);
      this.stage.addChild(container)
  }

  // - マスク -
  createMask(): TrimCjShape {
    const print = this.printManager.currentPrint;
    const base = print?.base.getImageWindow();
    if (!base) {
      throw new Error('printModel is notFound !!!!!!!!!')
    }
    const {virtual} = base;
    const {pos, wh} = virtual;
    const shape = new TrimCjShape();
    shape.graphics.f('#d30f7c').dr(0, 0, wh.width, wh.height);
    shape.name = CJ_FRAME_NAME.mask;
    shape.setBounds(0, 0, wh.width, wh.height);
    return shape;
  }


  createPhotoArea = async () => {
    const printBase = this.printManager.currentPrint?.base;
    const printFrame = printBase?.getImageWindow();
    if (!printFrame) return;
    const imageAreaContainer = new TrimCjContainer();

    const editorContainer = new TrimCjContainer();
    editorContainer.set({
      name: CJ_CONTAINER_NAME.editor,
      x: printFrame.virtual.pos.x,
      y: printFrame.virtual.pos.y,
      regX: printFrame.virtual.pos.x,
      regY: printFrame.virtual.pos.y,
    });
    const scaleContainer = new TrimCjContainer();
    scaleContainer.set({
      name: CJ_CONTAINER_NAME.scale,
      x: printFrame.virtual.pos.x + printFrame.virtual.wh.width / 2,
      y: printFrame.virtual.pos.y + printFrame.virtual.wh.height / 2,
      regX: printFrame.virtual.pos.x + printFrame.virtual.wh.width / 2,
      regY: printFrame.virtual.pos.y + printFrame.virtual.wh.height / 2,
      scaleX: 1,
      scaleY: 1,
    });
    const rotateContainer = new TrimCjContainer();
    rotateContainer.set({
      name: CJ_CONTAINER_NAME.rotate,
      x: printFrame.virtual.pos.x + printFrame.virtual.wh.width / 2,
      y: printFrame.virtual.pos.y + printFrame.virtual.wh.height / 2,
      regX: printFrame.virtual.pos.x + printFrame.virtual.wh.width / 2,
      regY: printFrame.virtual.pos.y + printFrame.virtual.wh.height / 2,
      rotation: 0,
      isRotate: false,
    });
    editorContainer.addChild(scaleContainer);
    scaleContainer.addChild(rotateContainer);
    imageAreaContainer.set({
      name: CJ_CONTAINER_NAME.imageArea,
      x: printFrame.virtual.pos.x,
      y: printFrame.virtual.pos.y,
      regX: printFrame.virtual.pos.x,
      regY: printFrame.virtual.pos.y,

    });
    imageAreaContainer.virtual = {
      x: printFrame.virtual.pos.x,
      y: printFrame.virtual.pos.y,
      width: printFrame.virtual.wh.width,
      height: printFrame.virtual.wh.height,
    }

    const imageMask = new TrimCjContainer();
    imageMask.name = CJ_CONTAINER_NAME.mask;
    const mask = this.createMask();
    imageMask.addChild(mask);
    imageAreaContainer.addChild(imageMask);
    imageMask.set({
      x: printFrame.virtual.pos.x,
      y: printFrame.virtual.pos.y,
      width: printFrame.virtual.wh.width,
      height: printFrame.virtual.wh.height,
      alpha: 1,
    });
    const hitArea = new TrimCjShape();
    hitArea.set({
      x: hitArea.x,
      y: hitArea.y,
      graphics: new TrimCjGraphics().f('#FFFFFF').dr(0, 0, printFrame.virtual.wh.width, printFrame.virtual.wh.height),
    });
    imageAreaContainer.hitArea = hitArea;

    // 写真移動時の境界線表示用DummyShape(左上から時計回りにA,B,C,D)
    const dummyFrame = new TrimCjContainer();
    const dummyRect = new TrimCjShape();
    const dummyCornerA = new TrimCjShape();
    const dummyCornerB = new TrimCjShape();
    const dummyCornerC = new TrimCjShape();
    const dummyCornerD = new TrimCjShape();
    dummyRect.graphics.f('#00f').dr(printFrame.virtual.pos.x, printFrame.virtual.pos.y, printFrame.virtual.wh.width, printFrame.virtual.wh.height);
    dummyCornerA.graphics.s('#00f').dc(printFrame.virtual.pos.x, printFrame.virtual.pos.y, 2);
    dummyCornerB.graphics.s('#00f').dc(printFrame.virtual.pos.x + printFrame.virtual.wh.width, printFrame.virtual.pos.y, 2);
    dummyCornerC.graphics.s('#00f').dc(printFrame.virtual.pos.x + printFrame.virtual.wh.width, printFrame.virtual.pos.y + printFrame.virtual.wh.height, 2);
    dummyCornerD.graphics.s('#00f').dc(printFrame.virtual.pos.x, printFrame.virtual.pos.y + printFrame.virtual.wh.height, 2);
    dummyRect.name = CJ_DPOBJ_NAME.dummyRect;
    dummyCornerA.name = CJ_DPOBJ_NAME.dummyCornerA;
    dummyCornerA.alpha = 0.01;
    dummyCornerB.name = CJ_DPOBJ_NAME.dummyCornerB;
    dummyCornerB.alpha = 0.01;
    dummyCornerC.name = CJ_DPOBJ_NAME.dummyCornerC;
    dummyCornerC.alpha = 0.01;
    dummyCornerD.name = CJ_DPOBJ_NAME.dummyCornerD;
    dummyCornerD.alpha = 0.01;
    dummyFrame.alpha = 0;
    dummyFrame.name = CJ_CONTAINER_NAME.dummyFrame;
    dummyFrame.addChild(dummyRect, dummyCornerA, dummyCornerB, dummyCornerC, dummyCornerD);
    imageAreaContainer.addChild(dummyFrame);

    rotateContainer.addChild(imageAreaContainer);

    console.log(editorContainer);
    this.stage.addChild(editorContainer);
    if (!this.printManager.editableImage) return;
    await this.thumbImageCreator.createPhotoImage(this.printManager.editableImage, editorContainer);
  };

  async createStageMask() {
    const base = {
      x: -this.thumbCreatorManager.STAGE_CONTAINER_X,
      y: -this.thumbCreatorManager.STAGE_CONTAINER_Y,
      w: ThumbCreatorManager.CANVAS_W,
      h: ThumbCreatorManager.CANVAS_H,
    };
    const window = {
      x: 0,
      y: 0,
      w: this.thumbCreatorManager.templateBaseVirtual.w,
      h: this.thumbCreatorManager.templateBaseVirtual.h,
    };
    console.log(base);
    console.log(window);

    this.trimAdditionalManager.drawBase(base, `#000`);
    this.trimAdditionalManager.clipWindow(base, window, 0, 'rect');
    const baseMaskContainer = new TrimCjContainer();
    baseMaskContainer.name = CJ_CONTAINER_NAME.baseMask;
    const baseMaskUrl = this.trimAdditionalManager.makeAdditional();
    const baseMaskWindow = new TrimCjBitmap(baseMaskUrl);
    baseMaskWindow.name = `${CJ_DPOBJ_NAME.baseMaskWindow}`;
    baseMaskContainer.addChild(baseMaskWindow);
    baseMaskContainer.set({
      x: base.x,
      y: base.y,
      alpha: 1,
      mouseEnable: false,
    });
    this.stage.addChild(baseMaskContainer);
    console.log(this.stage);
  }

}
